export const MACHINERY_STATUSES = [
  "Disponible",
  "En Uso",
  "Fallo",
  "Mantenimiento",
] as const;

export type MachineryStatus = (typeof MACHINERY_STATUSES)[number];

export const MACHINERY_DAYS = [
  { id: 0, label: "Domingo" },
  { id: 1, label: "Lunes" },
  { id: 2, label: "Martes" },
  { id: 3, label: "Miércoles" },
  { id: 4, label: "Jueves" },
  { id: 5, label: "Viernes" },
  { id: 6, label: "Sábado" },
] as const;

export interface MachineryShift {
  id: string;
  company_id: string;
  slug: string;
  machinery_id: string;
  day_of_week: number;
  day_label: string;
  start_time: string;
  end_time: string;
  display_start_time: string;
  display_end_time: string;
  duration_hours: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface Machinery {
  id: string;
  company_id: string;
  slug: string;
  name: string;
  type: string;
  description?: string | null;
  acquisition_date: string;
  status: MachineryStatus;
  daily_capacity_hours: number;
  technical_capacity_ratio: number;
  technical_capacity_unit?: string | null;
  technical_capacity_interval_minutes: number;
  technical_capacity_display?: string | null;
  is_active: boolean;
  active_shifts_count: number;
  shift_hours_by_day: Record<string, number>;
  shift_summary: string[];
  has_capacity_conflicts: boolean;
  shifts: MachineryShift[];
  created_at: string;
  updated_at: string;
}

export interface MachineryShiftConflict {
  type: "overlap" | "capacity_exceeded";
  day_of_week: number;
  day_label: string;
  message: string;
}

export interface MachineryShiftsResponse {
  machinery: Machinery;
  shifts: MachineryShift[];
  shift_hours_by_day: Record<string, number>;
  conflicts: MachineryShiftConflict[];
}

export interface CreateMachineryRequest {
  slug: string;
  company_id: string;
  name: string;
  type: string;
  description?: string;
  acquisition_date: string;
  status: MachineryStatus;
  daily_capacity_hours: number;
  technical_capacity_ratio: number;
  technical_capacity_unit?: string;
  technical_capacity_interval_minutes?: number;
}

export interface UpdateMachineryRequest {
  slug: string;
  company_id: string;
  name?: string;
  type?: string;
  description?: string;
  acquisition_date?: string;
  status?: MachineryStatus;
  daily_capacity_hours?: number;
  technical_capacity_ratio?: number;
  technical_capacity_unit?: string;
  technical_capacity_interval_minutes?: number;
}

export interface UpdateDailyCapacityRequest {
  slug: string;
  company_id: string;
  daily_capacity_hours: number;
}

export interface UpdateTechnicalCapacityRequest {
  slug: string;
  company_id: string;
  technical_capacity_ratio?: number;
  technical_capacity_unit?: string;
  technical_capacity_interval_minutes?: number;
}

export interface CreateMachineryShiftRequest {
  slug: string;
  company_id: string;
  day_of_week: number;
  start_time: string;
  end_time: string;
  is_active: boolean;
}

export interface UpdateMachineryShiftRequest {
  slug: string;
  company_id: string;
  day_of_week?: number;
  start_time?: string;
  end_time?: string;
  is_active?: boolean;
}
